/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManagementCompanyBoardMemberDto } from '../../models/management-company-board-member-dto';
import { ManagementCompanyBoardMemberRequestDto } from '../../models/management-company-board-member-request-dto';

export interface UpdateBoardMember$Params {
  managementCompanyId: string;
  boardMemberId: string;
      body: ManagementCompanyBoardMemberRequestDto
}

export function updateBoardMember(http: HttpClient, rootUrl: string, params: UpdateBoardMember$Params, context?: HttpContext): Observable<StrictHttpResponse<ManagementCompanyBoardMemberDto>> {
  const rb = new RequestBuilder(rootUrl, updateBoardMember.PATH, 'put');
  if (params) {
    rb.path('managementCompanyId', params.managementCompanyId, {});
    rb.path('boardMemberId', params.boardMemberId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManagementCompanyBoardMemberDto>;
    })
  );
}

updateBoardMember.PATH = '/management-companies/{managementCompanyId}/board-members/{boardMemberId}';
